import { createFileRoute } from '@tanstack/react-router'
import { SchoolStaffClient } from '../components/SchoolStaffClient'

export const Route = createFileRoute('/school/$schoolId/staff')({
  head: () => ({
    meta: [{ title: 'School Staff | Unbreakable' }],
  }),
  component: SchoolStaffPage,
})

function SchoolStaffPage() {
  return <SchoolStaffClient />
}
